/**
 * ToggleVisibilityDialog - Dialog for confirming visibility change of modules or submodules
 * Requires user to check confirmation checkbox to enable action button
 */
import InputCheckbox from '../../../../../atoms/InputCheckbox/InputCheckbox';
import Dialog from '../../../../../organisms/dialogs/Dialog/Dialog';
import React from 'react';
import useToggleVisibilityDialog from './useToggleVisibilityDialog';

type ToggleVisibilityDialogProps = {
  isOpen: boolean;
  type: 'module' | 'submodule';
  isHidden: boolean;
  onClose: () => void;
  onSuccess: () => void;
  isLoading?: boolean;
};

function ToggleVisibilityDialog({ isOpen, type, isHidden, onClose, onSuccess, isLoading = false }: ToggleVisibilityDialogProps): JSX.Element {
  const { t, title, questionText, checkboxLabel, disclaimerText, buttonText, isChecked, handleCheckboxChange, handleConfirm, handleClose, isDisabled } =
    useToggleVisibilityDialog({
      type,
      isHidden,
      onClose,
      onSuccess,
      isLoading,
    });

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      size="m"
      buttonTextCancel={t('actions:Cancel')}
      buttonTextSuccess={buttonText}
      onCancel={handleClose}
      onSuccess={handleConfirm}
      isDisabledSuccess={isDisabled}
      isLoading={isLoading}
    >
      <div className="toggle-visibility-dialog">
        <div className="toggle-visibility-dialog__question">{questionText}</div>
        <div className="toggle-visibility-dialog__checkbox">
          <InputCheckbox label={checkboxLabel} checked={isChecked} onChange={handleCheckboxChange} disabled={isLoading} />
        </div>
        <div className="toggle-visibility-dialog__disclaimer">
          <span>{disclaimerText}</span>
        </div>
      </div>
    </Dialog>
  );
}

ToggleVisibilityDialog.propTypes = {};

ToggleVisibilityDialog.defaultProps = {
  isLoading: false,
};

export default ToggleVisibilityDialog;

